<div
	class="slide slide--emotion-over-time"
	[style.--slide-accent-color]="titleColor"
>
	<div class="slide__header">
		<div class="slide__content-copy">
			<typography variant="h/2" class="slide__title">
				<app-report-inline-text
					[text]="title"
					[field]="textFields.title"
					[editorMode]="editorMode"
				></app-report-inline-text>
			</typography>
			<div class="slide__date-row">
				<app-icon type="svg" [size]="14">calendar_today</app-icon>
				<typography variant="p/xs_regular" class="slide__date-text">
					{{ dateLabel }}
				</typography>
			</div>
			<typography variant="p/sm_regular" class="slide__summary">
				<app-report-inline-text
					[text]="summaryText"
					[field]="textFields.body"
					[editorMode]="editorMode"
				></app-report-inline-text>
			</typography>
		</div>
		<div class="slide__kpi-block" *ngIf="!isEmpty && primaryKpi">
			<typography variant="h/1" class="slide__kpi-value">
				{{ primaryKpi.value }}
			</typography>
			<div class="slide__kpi-label-row">
				<span
					class="slide__kpi-dot"
					[style.background]="primaryKpi.color"
				></span>
				<typography variant="p/sm_regular" class="slide__kpi-label">
					{{ primaryKpi.label }}
				</typography>
			</div>
		</div>
	</div>

	<div class="slide__body" *ngIf="chartData && !isEmpty">
		<div class="slide__chart-head">
			<typography variant="p/sm_medium" class="slide__chart-title">
				{{ chartTitle }}
			</typography>
			<div class="slide__legend" *ngIf="legendItems.length">
				<div
					class="slide__legend-item"
					*ngFor="let item of legendItems; trackBy: trackByLegendId"
				>
					<span
						class="slide__legend-swatch"
						[style.background]="item.color"
					></span>
					<typography
						variant="p/xs_medium"
						class="slide__legend-label"
					>
						{{ item.label }}
					</typography>
				</div>
			</div>
		</div>
		<div class="slide__chart slide__chart-host">
			<canvas
				*ngIf="!chartSwitch.block"
				baseChart
				[data]="chartData"
				[options]="chartOptions"
				[type]="chartType"
			></canvas>
			<app-report-chart-switch
				[state]="chartSwitch"
				[themeColor]="themeColor"
				[editorMode]="editorMode"
				(chartTypeChange)="chartTypeChange.emit($event)"
			></app-report-chart-switch>
		</div>
	</div>

	<app-slide-no-data *ngIf="isEmpty"></app-slide-no-data>
	<div class="slide__footer">
		<app-report-slide-brand class="slide__footer-left">
			<typography variant="p/xxs_regular" class="slide__footer-copy">
				Powered by
			</typography>
			<typography variant="p/xxs_semibold" class="slide__footer-brand">
				lolly
			</typography>
		</app-report-slide-brand>
		<div class="slide__footer-tag">emotion over time</div>
	</div>
</div>
